import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateTimeForHomework extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("HomeWorks/CreateMasterHomeWork");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllMasterHomeworks extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("HomeWorks/GetAllMasterHomeWork");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class DeleteAMasterHomework extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("HomeWorks/DeleteByMasterHomeWork");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateAMasterHomework extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("HomeWorks/UpdateMasterHomeWork");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllReservedHomeworksPerDate extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("HomeWorks/GetAllHomeWorkPerDate");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetMasterHomeworkPaymentReport extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("HomeWorks/GetReportOfMastersHomeWorkPaymentPerMaster");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export {
  GetAllMasterHomeworks,
  CreateTimeForHomework,
  UpdateAMasterHomework,
  DeleteAMasterHomework,
  GetAllReservedHomeworksPerDate,
  GetMasterHomeworkPaymentReport,
};
